// Fisher-Yates shuffle algorithm.
// https://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle
export const shuffleArray = array => {
  // Copy the array to avoid mutating the original
  const result = [...array];

  // Iterate from the last element to the second element (index 1)
  // Each iteration places one element into its final shuffled position
  for (let currentIndex = result.length - 1; currentIndex > 0; currentIndex--) {
    // Generate a random index between 0 and currentIndex
    // This random index which will be swapped with the current index
    const randomIndex = Math.floor(Math.random() * (currentIndex + 1));

    // Swap elements at current index and random index
    [result[currentIndex], result[randomIndex]] = [result[randomIndex], result[currentIndex]];
  }
  return result;
};